<template>
  <page :title="$t('analytics.purchase_data')">
    <form class="card mb-8" @submit.prevent="generateReport">
      <div class="card-content">

        <div class="columns">
          <div class="column">
            <b-field :label="$tc('dater.range')" size="is-small">
              <b-select v-model="params.date_range" expanded>
                <option value="last_15_days">Last 15 days</option>
                <option value="today">Today</option>
                <option value="yesterday">Yesterday</option>
                <option value="this_week">This week</option>
                <option value="last_week">Last week</option>
                <option value="this_month">This month</option>
                <option value="last_month">Last month</option>
                <option value="this_year">This year</option>
                <option value="last_year">Last year</option>
                <option value="custom">Custom date range</option>
              </b-select>
            </b-field>
          </div>

          <div class="column">
            <div class="columns" v-if="params.date_range === 'custom'">
              <div class="column">
                <b-field label="Start Date">
                  <datepicker v-model="params.start_date" type="start_date" name="report"></datepicker>
                </b-field>
              </div>

              <div class="column">
                <b-field label="End Date">
                  <end-date-picker v-model="params.end_date" :limit="params.start_date"></end-date-picker>
                </b-field>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card-footer card-content">
        <div class="level-right">
          <a target="_blank" :href="generateReportUrlToDownload()" class="button">Download Data</a>
        </div>
      </div>
    </form>

    <div v-if="summarized" class="box" style="position: relative;">
      <div class="level is-middle is-mobile">
        <div class="level-left">
          <h1 class="title is-5 is-uppercase">Overall</h1>
        </div>

        <div class="level-right">
          <a :href="generateReportUrlToDownload()" class="button">Download Data</a>
        </div>
      </div>

      <b-table :data="summarized.data" narrowed sortable default-sort="total" default-sort-direction="desc" hoverable>
        <template slot-scope="props">
          <b-table-column label="Magazine">{{ props.row.magazine_name }}</b-table-column>

          <b-table-column label="Total" centered sortable field="total">{{ props.row.total }}</b-table-column>

          <b-table-column label="Apple" centered sortable field="ios_total">{{ props.row.ios_total }}</b-table-column>

          <b-table-column label="Android" centered sortable field="android_total">{{ props.row.android_total }}
          </b-table-column>
        </template>

        <template slot="footer">
          <td></td>

          <td class="has-text-centered">
            <strong>{{ summarized.totals.total }}</strong>
          </td>

          <td class="has-text-centered">
            <strong>{{ summarized.totals.ios_total }}</strong>
          </td>

          <td class="has-text-centered">
            <strong>{{ summarized.totals.android_total }}</strong>
          </td>
        </template>

        <template slot="empty">
          <empty-message></empty-message>
        </template>
      </b-table>

      <b-loading :active="processing" :is-full-page="false"></b-loading>
    </div>
  </page>
</template>

<script>

import EndDatePicker from "../../../../../components/EndDatepicker";

export default {
  components: {
    EndDatePicker,
  },

  data() {
    return {
      processing: false,

      params: {
        date_range: "this_month",
        start_date: null,
        end_date: null,
      },

      summarized: null,
    };
  },

  watch: {
    $route() {
      this.summarized = null;
    },
  },

  methods: {
    generateReport() {
      this.processing = true;

      this.$http
        .get(`/admin/api/analytics/order-analytics`, {
          params: this.params,
        })
        .then((res) => {
          this.processing = false;

          this.summarized = res.data;
        })
        .catch(() => {
          this.processing = false;
        });
    },

    queryString() {
      let params = {};

      for (let field in this.params) {
        if (this.params[field]) {
          params[field] = this.params[field];
        }
      }

      return new URLSearchParams(params).toString();
    },

    generateReportUrlToDownload() {
      return (
        `/admin/api/analytics/order-analytics?` + this.queryString()
      );
    },
  },
};
</script>
